import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  height: 100%;
  display: grid;
  place-items: center;
`;

export const Content = styled.div`
  color: #555;
  svg {
    max-height: 260px;
    height: 100%;
    margin-bottom: 16px;
  }

  h1 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.8rem;
    font-weight: bold;
  }

  p {
    margin: 0 auto;
    margin-bottom: 24px;
    max-width: 320px;
    font-size: 1rem;
  }
`;
